/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigDisplayKeyboardControlToggle_ConfigFragment = { __typename: 'ConfigurationModel', id: string, keyboardControl?: { __typename: 'ConfigControlState', reported: Types.ConfigControlLockState, supportedValues: Array<Types.ConfigControlLockState> } | null };

export type ConfigUpdateKeyboardControlMutationVariables = Types.Exact<{
  input: Types.ConfigurationUpdateKeyboardControlInput;
}>;


export type ConfigUpdateKeyboardControlMutation = { __typename: 'Mutation', configurationUpdateKeyboardControl: { __typename: 'ConfigurationModel', id: string, keyboardControl?: { __typename: 'ConfigControlState', reported: Types.ConfigControlLockState, supportedValues: Array<Types.ConfigControlLockState> } | null } };

export const ConfigDisplayKeyboardControlToggle_ConfigFragmentDoc = gql`
    fragment ConfigDisplayKeyboardControlToggle_config on ConfigurationModel {
  id
  keyboardControl {
    reported
    supportedValues
  }
}
    `;
export const ConfigUpdateKeyboardControlDocument = gql`
    mutation ConfigUpdateKeyboardControl($input: ConfigurationUpdateKeyboardControlInput!) {
  configurationUpdateKeyboardControl(input: $input) {
    id
    keyboardControl {
      reported
      supportedValues
    }
  }
}
    `;
export type ConfigUpdateKeyboardControlMutationFn = ApolloReactCommon.MutationFunction<ConfigUpdateKeyboardControlMutation, ConfigUpdateKeyboardControlMutationVariables>;

/**
 * __useConfigUpdateKeyboardControlMutation__
 *
 * To run a mutation, you first call `useConfigUpdateKeyboardControlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfigUpdateKeyboardControlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [configUpdateKeyboardControlMutation, { data, loading, error }] = useConfigUpdateKeyboardControlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useConfigUpdateKeyboardControlMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConfigUpdateKeyboardControlMutation, ConfigUpdateKeyboardControlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ConfigUpdateKeyboardControlMutation, ConfigUpdateKeyboardControlMutationVariables>(ConfigUpdateKeyboardControlDocument, options);
      }
export type ConfigUpdateKeyboardControlMutationHookResult = ReturnType<typeof useConfigUpdateKeyboardControlMutation>;
export type ConfigUpdateKeyboardControlMutationResult = ApolloReactCommon.MutationResult<ConfigUpdateKeyboardControlMutation>;
export type ConfigUpdateKeyboardControlMutationOptions = ApolloReactCommon.BaseMutationOptions<ConfigUpdateKeyboardControlMutation, ConfigUpdateKeyboardControlMutationVariables>;